import { theme, themeInverted } from './common';

/**
 * Foundation for the upcoming light/dark theme switch.
 */
export const getTheme: () => typeof theme = () => theme;

/**
 * Foundation for the upcoming light/dark theme switch (inverted variant).
 */
export const getInvertedTheme: () => typeof themeInverted = () => themeInverted;
